<template>
  <div class="creation-tab"
       :class="{'creation-tab__print': isStaticView}">
    <div v-if="briefContent.name !== ''" class="creation-tab__container">
<!--        <ContentElements-->
<!--          style="display: none"-->
<!--          ref="content-elements"-->
<!--          :content="briefContent"-->
<!--          isReversRow-->
<!--          recommendedLabel="Optimized"-->
<!--          currentLabel="Published"-->
<!--          hideFields-->
<!--          @apply="updateContentBrief" />-->
      <div class="creation-tab__row">
        <base-collapsible-block
          :disableCollapsing="isDrag"
          class="creation-tab__baseline"
          :class="{'creation-tab__baseline_uncollapsed': isBaselineCollapsed}"
          title="Baseline"
          maxHeight="479px"
          isCollapsed
          v-model="isBaselineCollapsed"
          :isStaticView="isStaticView">
          <template #header-additional>
            <div class="creation-tab__baseline_header">
              <div class="creation-tab__baseline_selector"  @click.stop="()=>{}">
                <template v-if="briefContent.baselines.length">
                  <button class="creation-tab__baseline_selector_button"
                          @click.prevent="showBaselineTable = !showBaselineTable">
                    {{ selectedBaselineName }}
                    <span></span>
                  </button>
                  <template v-if="showBaselineTable">
                    <div class="creation-tab__baseline_overlay" @click.prevent="showBaselineTable = false"></div>
                    <div class="creation-tab__baseline_selector_table-wrapper">
                      <div class="creation-tab__baseline_selector_table-wrapper_header">
                        <div class="creation-tab__baseline_selector_table-wrapper_header_title">Saved Baselines</div>
                        <span @click.prevent="showBaselineTable = false">&times;</span>
                      </div>
                      <div v-if="!isManageBaselineSelected" class="creation-tab__baseline_selector_table">
                        <div
                          class="creation-tab__baseline_selector_table_row creation-tab__baseline_selector_table_row-header">
                          <div class="creation-tab__baseline_selector_table_primary">Primary</div>
                          <div class="creation-tab__baseline_selector_table_label">Label</div>
                          <div class="creation-tab__baseline_selector_table_type">Type</div>
                          <div class="creation-tab__baseline_selector_table_date">Date</div>
                          <div class="creation-tab__baseline_selector_table_user">User</div>
                        </div>
                        <div class="creation-tab__baseline_selector_table_body">
                          <div v-for="item in briefContent.baselines"
                               :key="item.id"
                               class="creation-tab__baseline_selector_table_row"
                               :class="{ 'creation-tab__baseline_selector_table_row-selected': selectedBaselineId === item.id}"
                               @click.stop="selectBaseline(item.id, $event)">
                            <div class="creation-tab__baseline_selector_table_primary"><input @change="setPrimaryBaseline(item.id)" type="radio" :checked="item.is_primary" name="is-primary" ></div>
                            <div class="creation-tab__baseline_selector_table_label">{{ item.label }}</div>
                            <div class="creation-tab__baseline_selector_table_type">{{ item.type }}</div>
                            <div class="creation-tab__baseline_selector_table_date">{{ item.date }}</div>
                            <div class="creation-tab__baseline_selector_table_user">
                              <span class="creation-tab__baseline_selector_table_user_email">{{ item.user }}</span>
                              <div class="creation-tab__baseline_selector_table_user_manage-wrapper">
                                <base-material-design-icon v-if="selectedBaselineId === item.id"
                                                           class="creation-tab__baseline_selector_table_checkbox"
                                                           icon="check"/>
                                <TitleDropdownMenu class="creation-tab__baseline_selector_table_3-dots"
                                                   :options="dropdownOptions"
                                                   @menuItem="onItemClick($event, item)"/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="creation-tab__baseline_selector_table">
                        <div class="creation-tab__baseline_selector_table_row creation-tab__baseline_selector_table_row-header">
                          <div class="creation-tab__baseline_selector_table_label">Label</div>
                        </div>
                        <div class="creation-tab__baseline_selector_table_row">
                          <input class="creation-tab__baseline_change-label-field"
                                 :class="{ 'creation-tab__baseline_change-label-field-error': manageBaseLineError }"
                                 type="text"
                                 v-model="manageBaseLine.label">
                        </div>
                        <span v-if="manageBaseLineError" class="creation-tab__baseline_change-label-field_error-message">
                          {{ manageBaseLineError }}
                        </span>
                        <div class="content-elements">
                          <div class="content-elements__controls">
                            <button class="content-elements__button content-elements__button_cancel"
                                    @click.prevent="cancelBaselineLabelChange">Cancel
                            </button>
                            <button class="content-elements__button content-elements__button_submit"
                                    @click.prevent="saveBaselineLabel">Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
              <button class="creation-tab__copy-baseline"
                      v-if="hasVersions"
                      @click.stop.prevent="copyToClipboard">
                <base-material-design-icon icon="copy"/>
              </button>
              <button class="creation-tab__create-new-baseline"
                      @click.stop.prevent="openCreateNewBaselineModal(false)">
                <base-material-design-icon icon="plusCircle"/>
                create new
              </button>
            </div>
          </template>
            <ContentElements
              :content="selectedBaselineContentElements"
              :subtitleStyles="{ height: '16px', marginTop: '12px', marginBottom: '-12px' }"
              showField="published"
              hideRefresh
              staticHeight
              hideLabels
              hideFields/>
          <div :style="{'height': isBaselineCollapsed ? '75px' : '34px' }" class="creation-tab__baseline_content-uncollapsed"></div>
<!--          <div class="creation-tab__baseline_content"-->
<!--               :class="{ 'creation-tab__baseline_content_collapsed': !isBaselineCollapsed }"-->
<!--               v-html="selectedBaselineContent"></div>-->
            <div ref="editor-2"
                 class="creation-tab__baseline_content"
                 :class="{ 'creation-tab__baseline_content_collapsed': !isBaselineCollapsed}">
              <Editor
                v-model="selectedBaselineContent"
                :init="{
                  verify_html: false,
                  menubar: false,
                  statusbar: false,
                  plugins: 'advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount hr',
                  toolbar: '',
                  height: '121px'
                }"
                @onInit="resizeHandler('editor-2', true)"
                @onKeyPress.prevent="()=>{}"
              />
            </div>
            <div v-if="!selectedBaselineContent" class="creation-tab__empty-baseline">No Baseline</div>
        </base-collapsible-block>
        <base-collapsible-block
          :disableCollapsing="isDrag"
          class="creation-tab__optimized"
          title="Optimized"
          maxHeight="479px"
          isCollapsed
          v-model="isBaselineCollapsed"
          :isStaticView="isStaticView">
          <template #header-additional>
            <div class="creation-tab__optimized_header">
              <button class="creation-tab__save-as-baseline"
                      :class="{'creation-tab__save-as-baseline_disabled': !briefContent.content_optimized}"
                      @click.stop.prevent="openCreateNewBaselineModal(true)">
                <base-material-design-icon icon="save"/>
                save as new baseline
              </button>
              <button class="creation-tab__clone-baseline"
                      :class="{ 'creation-tab__clone-baseline_disabled': !selectedBaselineContent }"
                      @click.stop.prevent="cloneBaseline(true)">
                <base-material-design-icon icon="copy"/>
                clone baseline
              </button>
            </div>
          </template>
          <ContentElements
            :content="briefContentCreation"
            :subtitleStyles="{ height: '16px', marginTop: '12px', marginBottom: '-12px' }"
            showField="recommended"
            recommendedTitleKey="tag_title_optimized"
            recommendedDescriptionKey="tag_meta_description_optimized"
            staticHeight
            hideRefresh
            hideLabels
            hideFields
            @apply="updateContentBrief"/>
          <div v-if="isBaselineCollapsed && !isDrag" class="creation-tab__optimized_difference creation-tab__optimized_difference-uncollapsed">
            <span>Character Difference: <span class="creation-tab__optimized_difference_score">{{ difference.charDiff }}</span></span>
            <span>Word Difference: <span class="creation-tab__optimized_difference_score">{{ difference.wordDiff }}</span></span>
            <span>Total Word Count: <span class="creation-tab__optimized_difference_score">{{ difference.wordCount }}</span></span>
          </div>
          <div class="creation-tab__editor-drag-wrapper">
            <VueDraggableResizable
              class-name="creation-tab__editor-drag-wrapper_vdr"
              :draggable="isDrag"
              :resizable="isDrag"
              ref="editor-drag"
              class-name-draggable="creation-tab__editor-drag-wrapper_dragging"
              :h="230"
              :w="editorWidth"
              :z="100"
              @resizing="resizeHandlerVue"
              :min-height="230"
              :min-width="650"
            >
              <base-material-design-icon
                :style="dragButtonStyles"
                class="creation-tab__editor-drag-wrapper_collapse-button"
                :icon="!isDrag ? 'expand' : 'collapse'"
                @click="changeDragState"/>
              <div class="creation-tab__optimized_content">
                <div ref="editor">
                  <Editor
                    v-model="briefContent.content_optimized"
                    :init="{
                      verify_html: false,
                      selector: 'textarea',
                      menubar: false,
                      statusbar: false,
                      plugins: 'advlist code autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount textcolor colorpicker hr',
                      toolbar: 'formatselect forecolor backcolor bold italic link bullist numlist image table code undo redo removeformat hr',
                      height: '151px',
                      invalid_elements: 'style,script',
                      setup: function (editor) {
                        tinyMCE = editor
                        editor.on('init', () => {
                          initialOptimizedContent = editor.getContent();
                        })
                      }
                    }"
                    @onInit="onEditorInit"
                    @onFocusIn="isOptimizedFocused = true"
                    @onFocusOut="isOptimizedFocused = false"
                  />
                </div>
                <div v-if="!isBaselineCollapsed || isDrag" class="creation-tab__optimized_difference">
                  <template v-if="briefContent.content_optimized">
                  <span>
                    Character Difference:
                    <span class="creation-tab__optimized_difference_score"> {{ difference.charDiff }}</span>
                  </span>
                  <span>
                    Word Difference:
                    <span class="creation-tab__optimized_difference_score"> {{ difference.wordDiff }}</span>
                  </span>
                  <span>
                    Total Word Count:
                    <span class="creation-tab__optimized_difference_score"> {{ difference.wordCount }}</span></span>
                  </template>
                  <span class="creation-tab__optimized_difference_autosave">
                    autosave enabled
                  </span>
                </div>
                <div v-if="isBaselineCollapsed && !isDrag" class="content-elements">
                  <div class="content-elements__controls">
                    <button class="content-elements__button content-elements__button_submit"
                            :class="{'create-new-baseline__button_disabled': disableSaveOptimized}"
                            @click.prevent="saveOptimized()">Save
                    </button>
                  </div>
                </div>
                <div v-if="!briefContent.content_optimized && !isOptimizedFocused" class="creation-tab__empty-baseline">
                  No Content
                </div>
              </div>
            </VueDraggableResizable>
          </div>
        </base-collapsible-block>
      </div>

      <div class="creation-tab__row keywords-table">
        <Keywords :keywords="keywords"
                  ref="keywords"
                  isBaselineDisplay
                  :cbVersionId="selectedBaselineId"
                  :optimizedContent="briefContent.content_optimized"
                  :isStaticView="isStaticView"
                  :isKeywordsPresent="isKeywordsPresent"
                  @update-score="$emit('update-score', $event)"/>
      </div>
    </div>

    <modal name="create-new"
           v-bind="createBaselineModalProps">
      <CreateNewBaseline
        :saveAsBaseline="saveAsBaseline"
        :optimized="briefContent.content_optimized"
        :url="briefContent.published_url || briefContent.url"
        :descriptionOptimized="briefContent.tag_meta_description_optimized"
        :titleOptimized="briefContent.tag_title_optimized"
        :isPublished="isPublished"
        :invalidImageURLs="invalidImageURLs"
        :briefId="briefContent._id"
        @close="closeCreateNewBaselineModal"/>
    </modal>
     <modal name="confirm-modal" v-bind="confirmModalProps">
       <base-confirm-modal :title="modalConfirmTitle"
                           :subtitle="modalConfirmSubTitle"
                           @confirm="confirmModal"/>
     </modal>
     <modal name="confirm-replace-modal" v-bind="confirmBaselineModalProps">
       <base-confirm-replace-modal
         :tableHeader="confirmBaselineTableHeaders"
         :tableRow="confirmBaselineTableRows"
         :subtitle="modalConfirmSubTitle"
         @confirm="confirmModal"
       />
     </modal>
    <div v-if="isDrag" ref="optional-style">
    </div>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import ContentElements from './ContentElements'
import CreateNewBaseline from './CreateNewBaseline'
import Keywords from './Keywords'
import TitleDropdownMenu from './TitleDropdownMenu'
import VueDraggableResizable from 'vue-draggable-resizable'
import Editor from '@tinymce/tinymce-vue'
import baseModalProps from '@/common/BaseModalProps'
import _ from 'lodash'
import ToasterService from '@/services/toasterService'
const image404 = require('@/assets/image-404.svg')

const DROPDOWN_OPTIONS = [
  {
    label: 'Edit',
    id: 'edit'
  },
  {
    label: 'Delete',
    id: 'delete'
  }
]
const DIFFERENCE = {
  charDiff: 0,
  wordDiff: 0,
  wordCount: 0
}
const confirmBaselineTableHeaders = ['', 'Replace', 'Do Not Replace']
const confirmBaselineTableRows = [
  'Replace Existing Optimized Metadata with Baseline Metadata?',
  'Replace Existing Optimized Content with Baseline Content?'
]
export default {
  name: 'CreationTab',
  components: { ContentElements, VueDraggableResizable, CreateNewBaseline, TitleDropdownMenu, Editor, Keywords },
  props: {
    isStaticView: {
      type: Boolean,
      default: false
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   if (this.isOptimizedDirty) {
  //     const answer = window.confirm('Do you really want to leave? Your Optimized Content is not saved!')
  //     if (!answer) {
  //       return false
  //     }
  //   }
  //   next()
  //   return
  // },
  beforeDestroy () {
    document.removeEventListener('scroll', this.handleEditorHeaderScroll)
  },
  mounted () {
    const editorWidth = document.querySelector('.serp-simulator').getBoundingClientRect().width + 48
    this.editorWidth = editorWidth > 650 ? editorWidth : 650
    const primaryBaseline = this.briefContent.baselines.find(baseline => baseline.is_primary)
    this.selectedBaselineId = primaryBaseline ? primaryBaseline.id : this.briefContent.baselines[0].id
  },
  data () {
    return {
      isDataUpdating: false,
      initialOptimizedContent: null,
      tinyMCE: null,
      isBaselineCollapsed: false,
      isOptimizedFocused: false,
      saveAsBaseline: false,
      disableSaveOptimized: false,
      styleAdded: false,
      selectedBaselineId: null,
      manageBaseLine: {},
      manageBaseLineId: '',
      invalidImageURLs: [],
      confirmBaselineTableHeaders: _.cloneDeep(confirmBaselineTableHeaders),
      editorWidth: 650,
      isDrag: false,
      dragButtonStyles: {
        top: '6px'
      },
      manageBaseLineError: '',
      difference: { ...DIFFERENCE },
      showBaselineTable: false,
      dropdownOptions: _.cloneDeep(DROPDOWN_OPTIONS),
      hasVersions: false
    }
  },
  watch: {
    'briefContent.baselines': {
      handler (v) {
        if (v && v.length === 1) {
          this.hasVersions = true
          this.selectedBaselineId = this.briefContent.baselines[0].id
          this.briefContent.baselines[0].is_primary = true
        }
      },
      immediate: true,
      deep: true
    },
    async isDrag (v) {
      await this.$nextTick()
      this.resizeHandlerVue(null, null, null, this.$refs['editor-drag'].height)
    },
    isBaselineCollapsed () {
      this.resizeHandler('editor')
      this.resizeHandler('editor-2')
      if (!v) {
        document.removeEventListener('scroll', this.handleEditorHeaderScroll)
        const header = this.$refs['editor'].querySelector('.mce-top-part')
        header.style.top = '0px'
        header.style.width = '100%'
      } else {
        document.addEventListener('scroll', this.handleEditorHeaderScroll)
        this.handleEditorHeaderScroll()
      }
    },
    'briefContent.content_optimized': async function () {
      this.debounceContentOptimized()
      await this.resizeHandler('editor', true)
    },
    selectedBaselineContent () {
      this.resizeHandler('editor-2')
      this.validateImages('editor-2')
      // for difference recalculation
      this.resizeHandler('editor')
    },
    invalidImageURLs: {
      handler (v) {
        const div = document.createElement('div')
        div.innerHTML = this.briefContent.content_optimized
        v.forEach(url => {
          const images = div.querySelectorAll(`img[src="${url}"]`) || []
          images.forEach(img => {
            img.src = image404
            img.setAttribute('width', '64px')
          })
        })
        if (div.innerHTML !== this.briefContent.content_optimized) {
          this.briefContent.content_optimized = div.innerHTML
        }
      },
      deep: ''
    }
  },
  computed: {
    ...mapState('briefContent', ['briefContent']),
    isOptimizedDirty() {
      return this.initialOptimizedContent !== this.tinyMCE.getContent();
    },
    selectedBaselineContent () {
      const baseline = this.briefContent.baselines.find(i => i.id === this.selectedBaselineId)
      const div = document.createElement('div')
      div.innerHTML = this.validateContent(baseline?.content || '')
      this.invalidImageURLs.forEach(url => {
        const images = div.querySelectorAll(`img[src="${url}"]`) || []
        images.forEach(img => {
          img.src = image404
          img.setAttribute('width', '64px')
        })
      })
      return div.innerHTML
    },
    selectedBaselineContentElements () {
      const selectedBaselineContent = this.briefContent.baselines.find(i => i.id === this.selectedBaselineId)
      return {
        published_url: this.briefContent.published_url,
        url: this.briefContent.url,
        tag_title_current: selectedBaselineContent?.tag_title || '',
        tag_meta_description_current: selectedBaselineContent?.tag_meta_description || '',
        url_status: 'Published'
      }
    },
    briefContentCreation () {
      return {
        ...this.briefContent,
        tag_title_baseline: this.selectedBaselineContentElements.tag_title_current,
        tag_meta_description_baseline: this.selectedBaselineContentElements.tag_meta_description_current
      }
    },
    confirmBaselineTableRows () {
      const contentOptimized = (this.briefContent.content_optimized || '').trim()
      const tagTitleOptimized = (this.briefContent.tag_title_optimized || '').trim()
      const tagMetaDescOptimized = (this.briefContent.tag_meta_description_optimized || '').trim()
      return contentOptimized &&
      !tagTitleOptimized &&
      !tagMetaDescOptimized
        ? [confirmBaselineTableRows[1]]
        : !contentOptimized &&
        tagTitleOptimized &&
        tagMetaDescOptimized
          ? [confirmBaselineTableRows[0]]
          : confirmBaselineTableRows
    },
    selectedBaselineName () {
      const label = this.briefContent.baselines.find(i => i.id === this.selectedBaselineId).label
      const truncatedLabel = label.slice(0, 35)
      return truncatedLabel + (truncatedLabel.length < label.length ? '...' : '')
    },
    isManageBaselineSelected () {
      return !!Object.keys(this.manageBaseLine).length
    },
    createBaselineModalProps () {
      return { ...baseModalProps, width: '80%' }
    },
    confirmModalProps () {
      return { ...baseModalProps, height: 'auto', width: '510px' }
    },
    confirmBaselineModalProps () {
      return { ...baseModalProps, height: 'auto', width: '730px' }
    },
    modalConfirmTitle () {
      return `Are you sure you want to ${this.manageBaseLineId ? 'delete this?' : 'overwrite your current Optimized Content?'}`
    },
    modalConfirmSubTitle () {
      return this.manageBaseLineId
        ? 'This Baseline will be removed permanently!'
        : 'Warning: Selecting REPLACE will delete existing information permanently'
    },
    keywords () {
      return this.briefContent.keywords
    },
    isKeywordsPresent () {
      return !!(this.briefContent.keywords && this.briefContent.keywords.length)
    },
    isPublished () {
      return _.get(this.briefContent, 'url_status', '').toLowerCase() === 'published'
    },
    isOptimizedEmpty () {
      return !(this.briefContent.content_optimized || '').trim() &&
        !(this.briefContent.tag_title_optimized || '').trim() &&
        !(this.briefContent.tag_meta_description_optimized || '').trim()
    }
  },
  methods: {
    ...mapActions('briefContent', [
      'changeContentBrief',
      'createContentBriefVersion',
      'changeContentBriefVersion',
      'deleteContentBriefVersion',
      'changePrimaryBaseline'
    ]),
    async updateContentBrief (payload) {
      try {
        await this.changeContentBrief(payload)
      } catch (e) {
      }
    },
    async setPrimaryBaseline (baselineId) {
      try {
        await this.changePrimaryBaseline({ baselineId })
      } catch (e) {

      }
    },
    selectBaseline (baselineId, event) {
      if (event.target.type !== 'radio') { // allow setting primary without changing selected baseline
        this.selectedBaselineId = baselineId
      }
    },
    async changeDragState () {
      this.isDrag = !this.isDrag
      const html = document.querySelector('html');
      if (!this.isDrag) {
        html.classList.remove('tiny-mce-draggable');
        await this.$nextTick()
        await this.resizeHandler('editor')
        await this.resizeHandler('editor-2')
        await this.$nextTick()
        await this.$nextTick()
        this.handleEditorHeaderScroll()
      } else {
        html.classList.add('tiny-mce-draggable');
        const header = this.$refs['editor'].querySelector('.mce-top-part')
        header.style.top = '0px'
        this.dragButtonStyles.top = '6px'
        await this.$nextTick()
        const height = window.innerHeight * 0.75
        this.resizeHandlerVue(null, null, null, height)
      }
    },
    async onEditorInit () {
      await this.resizeHandler('editor', true)
      const iFrame = this.$refs['editor'].querySelector('iframe')
      let height = iFrame.contentWindow.document.body.offsetHeight
      if (height <= 230) {
        height = 230
      }
    },
    validateContent (content) {
      const scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi
      const styleRegex = /<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi
      return content.replace(scriptRegex, '').replace(styleRegex, '')
    },
    async handleEditorHeaderScroll (skipChange = false) {
      if (this.isDrag && !skipChange) {
        return
      }
      const editor = this.$refs['editor']
      const editorRect = editor.getBoundingClientRect()
      const header = editor.querySelector('.mce-top-part')
      if (!header) {
        await this.$nextTick()
        return this.handleEditorHeaderScroll()
      }
      header.style.width = '100%'
      if (editorRect.y >= 50) {
        header.style.top = '0px'
        this.dragButtonStyles.top = '6px'
      } else if (Math.abs(editorRect.y) >= editorRect.height - 200) {
        let top = editorRect.height - 150
        top = top >= 0 ? top : 0
        header.style.top = top + 'px'
        this.dragButtonStyles.top = top + 6 + 'px'
      } else {
        let top = 50 - editorRect.y
        top = Math.abs(top === 0 ? 50 : top < 0 ? top - 50 : top)
        header.style.top = top + 'px'
        this.dragButtonStyles.top = top + 6 + 'px'
      }
      return this.dragButtonStyles.top
    },
    copyToClipboard () {
      this.$copyText(this.selectedBaselineContent)
        .then(
          e => {
            ToasterService.showToast(ToasterService.INFO_TYPE, 'Baseline Content copied to clipboard')
          },
          err => {
            ToasterService.showToast(ToasterService.ERROR_TYPE, 'Can not copy baseline content. Please, copy it manually')
          }
        )
    },
    openEditMetaDataModal () {
      this.$refs['content-elements'].openEditModal()
    },
    async validateImages (editor) {
      const editorParent = this.$refs[editor]
      if (editorParent) {
        const iframe = editorParent.querySelector('iframe')
        await this.$nextTick()
        const body = iframe.contentWindow.document.body
        const images = body.querySelectorAll('img')
        images.forEach(img => {
          img.removeAttribute('onerror')
          img.removeAttribute('onload')
          img.addEventListener('error', () => {
            // img.setAttribute('width', '64px')
            this.invalidImageURLs.push(img.getAttribute('src'))
            img.addEventListener('load', () => {
              this.resizeHandler(editor)
            })
          })
        })
        iframe.contentWindow.document.body = body
      }
    },
    cloneBaselineContent () {
      this.briefContent.content_optimized = this.selectedBaselineContent
    },
    cloneBaselineMetaDesc () {
      this.briefContent.tag_meta_description_optimized = this.briefContentCreation.tag_meta_description_baseline
      this.briefContent.tag_title_optimized = this.briefContentCreation.tag_title_baseline
    },
    cloneBaseline (showModal = false, updateStatus = []) {
      if (showModal && !this.isOptimizedEmpty) {
        this.$modal.show('confirm-replace-modal')
      } else {
        if (showModal && this.isOptimizedEmpty) {
          updateStatus = ['true', 'true']
        }
        if (updateStatus.length === 2) {
          const copyConfirmBaselineTableRows = _.cloneDeep(this.confirmBaselineTableRows)
          for (let i = 0; i < updateStatus.length; i++) {
            if (updateStatus[i] === 'true') {
              switch (copyConfirmBaselineTableRows[i]) {
                case confirmBaselineTableRows[0]:
                  this.cloneBaselineMetaDesc()
                  break
                case confirmBaselineTableRows[1]:
                  this.cloneBaselineContent()
                  break
              }
            }
          }
        } else {
          switch (this.confirmBaselineTableRows[0]) {
            case confirmBaselineTableRows[0]:
              if (updateStatus[0] === 'true') {
                this.cloneBaselineMetaDesc()
              }
              this.cloneBaselineContent()
              break
            case confirmBaselineTableRows[1]:
              if (updateStatus[0] === 'true') {
                this.cloneBaselineContent()
              }
              this.cloneBaselineMetaDesc()
              break
          }
        }
      }
    },
    debounceContentOptimized: _.debounce(function() {
      this.saveOptimized(true)
    }, 2000),
    async saveOptimized (silentMode) {
      this.disableSaveOptimized = true
      const payload = {
        clientId: this.clientId,
        briefId: this.briefContent._id,
        content_optimized: this.briefContent.content_optimized,
        tag_title_optimized: this.briefContent.tag_title_optimized,
        tag_meta_description_optimized: this.briefContent.tag_meta_description_optimized
      }
      await this.changeContentBrief({ ...payload, silentMode })
      this.initialOptimizedContent = this.briefContent.content_optimized
      this.$refs.keywords.getKissScore()
      this.disableSaveOptimized = false
    },
    resizeHandlerVue (l, t, w, h) {
      // this.$refs.editor.firstChild.setAttribute('style', `height:${h - 30}px;`)
      const iFrame = this.$refs.editor.firstChild.querySelector('iframe')
      iFrame && iFrame.setAttribute('style', `height:${h - 80}px; width: -webkit-fill-available; padding: 8px 16px;`)
      // iFrame && iFrame.setAttribute('style', `height:${h}px; width: ${w}px; padding: 8px 16px;`)
    },
    async resizeHandler (editor = 'editor', validateImages = false) {
      validateImages && this.validateImages(editor)
      const editorParent = this.$refs[editor]
      if (!editorParent) {
        return
      }
      await this.$nextTick()
      const iframe = editorParent.querySelector('iframe')
      if (!iframe) {
        return
      }
      // if (editor === 'editor-2') {
      //   this.$refs[editor].activeEditor.getBody().setAttribute('contenteditable', false)
      // }
      if (!this.styleAdded || editor === 'editor-2') {
        editor !== 'editor-2' && (this.styleAdded = true)
        const style = document.createElement('style')
        style.innerHTML = `
          img {
            max-width: 100% !important;
          }
          ${editor === 'editor-2'
              ? `
                        body {
                          outline: none;
                          color: transparent;
                          text-shadow: 0 0 black;
                        }`
              : ''
          }
        `
        iframe.contentWindow.document.head.appendChild(style)
      }
      let height = 151
      if (!this.isBaselineCollapsed && (!this.isDrag || editor === 'editor-2')) {
        iframe.setAttribute('style', `height: ${height}px; width: -webkit-fill-available; padding: 8px 16px;`)
      } else if (!this.isDrag || editor === 'editor-2') {
        height = iframe.contentWindow.document.body.offsetHeight + 44
        iframe.setAttribute('style', `height: ${height}px; width: -webkit-fill-available; padding: 8px 16px;`)
      }
      if (editor === 'editor') {
        this.difference = { ...DIFFERENCE }
        if (this.briefContent.content_optimized) {
          const mapper = str => {
            const div = document.createElement('div')
            div.innerHTML = str
            div.innerHTML = div.textContent.replace(/\n/g, ' ')
            const wordsArray = div.innerHTML.replace(/&nbsp;/g, ' ').split(' ').reduce((arr, item) => {
              item = item.replace(/\s/g, '')
              if (item) {
                arr.push(item)
              }
              return arr
            }, [])
            return {
              words: wordsArray.length,
              char: wordsArray.join('').length
            }
          }

          const baseline = mapper(this.selectedBaselineContent)
          const optimized = mapper(this.briefContent.content_optimized)

          const wordDiffNumber = optimized.words - baseline.words
          const charDiff = optimized.char - baseline.char
          this.difference.wordDiff = (wordDiffNumber === 0 ? '' : wordDiffNumber > 0 ? '+' : '-') + Math.abs(wordDiffNumber)
          this.difference.charDiff = (charDiff === 0 ? '' : charDiff > 0 ? '+' : '-') + Math.abs(charDiff)
          this.difference.wordCount = optimized.words
        }
      }
      return height
    },
    openCreateNewBaselineModal (saveAsBaseline = false) {
      if (saveAsBaseline && !this.briefContent.content_optimized) {
        return
      }
      if (this.isDrag) {
        this.changeDragState()
      }
      this.saveAsBaseline = saveAsBaseline
      this.$modal.show('create-new')
    },
    closeCreateNewBaselineModal (data) {
      this.$modal.hide('create-new')
      this.saveAsBaseline = false
      if (data) {
        data.briefId = this.briefContent._id
        this.createContentBriefVersion(data)
        this.hasVersions = true
      }
    },
    confirmModal (status) {
      this.$modal.hide('confirm-modal')
      this.$modal.hide('confirm-replace-modal')
      if (status) {
        if (this.manageBaseLineId) {
          this.deleteContentBriefVersion({
            cbVersionId: this.manageBaseLineId,
            briefId: this.briefContent._id
          })
        } else {
          this.cloneBaseline(false, status)
        }
      } else {
        this.manageBaseLineId = ''
      }
    },
    cancelBaselineLabelChange () {
      this.manageBaseLineError = ''
      this.manageBaseLine.label = this.manageBaseLine.prevLabel
      this.manageBaseLine = {}
    },
    saveBaselineLabel () {
      this.manageBaseLineError = ''
      if (!this.manageBaseLine.label.trim()) {
        this.manageBaseLineError = 'Label field is required'
      } else {
        this.changeContentBriefVersion({
          cbVersionId: this.manageBaseLineId,
          briefId: this.briefContent._id,
          cbVersionLabel: this.manageBaseLine.label
        })
        this.manageBaseLine = {}
      }
    },
    onItemClick (item, data) {
      this.manageBaseLineId = data.id
      switch (item) {
        case 'delete':
          this.$modal.show('confirm-modal')
          break
        case 'edit':
          this.manageBaseLine = data
          this.manageBaseLine.prevLabel = data.label
          this.manageBaseLine.error = ''
          break
      }
    }
  }
}

</script>

<style scoped lang="scss">

  .keywords-table {
    margin-top: 5%;
  }
  .creation-tab {
    &__empty-baseline {
      color: $rfx-shaded-grey;
      font-size: 18px;
      font-weight: 500;
      position: absolute;
      top: 100.5px;
      left: calc(50% - 48.21px );
    }

    &__container {
      min-width: 964px;
    }

    &__row {
      display: flex;
    }

    &__optimized,
    &__baseline {
      flex: 1 1;
      margin-top: 0 !important;
    }

    &__baseline {
      margin-right: 8px;

      &_uncollapsed {
        .creation-tab__empty-baseline {
          bottom: 15px !important;
        }
      }

      .creation-tab__empty-baseline {
        top: auto !important;
        bottom: 103px;
      }

      &_change-label-field {
        flex: 1;
        padding: 8px 16px;
        border-radius: 4px;
        border: 1px solid rgba(1, 22, 39, 0.1);
        color: $rfx-dark-march;

        &_error-message {
          display: block;
          color: $rfx-red;
          font-size: 10px;
          margin-top: 5px;
          padding-left: 0;
        }

        &-error {
          color: $rfx-red;
          border-color: $rfx-red;
        }
      }

      &::v-deep .collapsible__header-slot-wrapper {
        overflow: visible;
      }

      &_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: -webkit-fill-available;
      }

      &_overlay {
        width: 100vw;
        height: 100vh;
        position: fixed;
        cursor: default;
        left: 0;
        top: 0;
        z-index: 99;
      }

      &_selector {
        position: relative;

        &_table {
          width: 951px;

          &-wrapper {
            z-index: 100;
            padding: 16px;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 15px 32px 0 rgba(96, 97, 112, 0.28), 0 1px 8px 0 rgba(40, 41, 61, 0.1);
            position: absolute;
            left: -104px;
            top: 35px;

            &_header {
              display: flex;
              justify-content: space-between;
              margin-bottom: 8px;

              &_title {
                font-size: 16px;
                color: $rfx-dark-march;
                font-weight: 500;
                line-height: 20px;
              }

              span {
                font-size: 28px;
                height: 0px;
                color: #011627;
                margin-top: -7px;
              }
            }
          }

          &_row {
            display: flex;

            &-header {
              .creation-tab__baseline_selector_table_primary,
              .creation-tab__baseline_selector_table_label,
              .creation-tab__baseline_selector_table_type,
              .creation-tab__baseline_selector_table_date,
              .creation-tab__baseline_selector_table_user {
                border-color: transparent !important;
                color: $rfx-dark-march;
                font-weight: bold;
              }
            }

            &-selected {
              .creation-tab__baseline_selector_table_primary,
              .creation-tab__baseline_selector_table_label,
              .creation-tab__baseline_selector_table_type,
              .creation-tab__baseline_selector_table_date,
              .creation-tab__baseline_selector_table_user {
                color: #fff !important;
                background: $rfx-bright-blue;

                .creation-tab__baseline_selector_table_3-dots {
                  &::v-deep .title-dropdown-menu__icon {
                    background-color: #fff;

                    &:before,
                    &:after {
                      background-color: #fff;
                    }
                  }
                }
              }
            }
          }

          &_checkbox {
            font-size: 18px;
          }

          &_3-dots {
            margin-right: -8px;
            margin-left: 12px;
            position: relative;
          }

          &_column {
            padding: 8px 16px;
            font-size: 14px;
            color: $rfx-dark-march;
            line-height: 20px;
            border-left: 1px solid #e6e8ea;
          }

          &_body {
            border-top: 1px solid #e6e8ea;
            border-right: 1px solid #e6e8ea;
            border-bottom: 1px solid #e6e8ea;

            .creation-tab__baseline_selector_table_row {
              border-bottom: 1px solid #e6e8ea;
            }
          }

          &_primary {
            @extend .creation-tab__baseline_selector_table_column;
            flex: 0 0 50px;
            overflow: hidden;
            text-align: center;
            > input {
              transform: scale(1.5);
              cursor: pointer;
            }
          }

          &_label {
            @extend .creation-tab__baseline_selector_table_column;
            flex: 0 0 257px;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          &_type {
            @extend .creation-tab__baseline_selector_table_column;
            flex: 0 0 130px;
          }

          &_date {
            @extend .creation-tab__baseline_selector_table_column;
            flex: 0 0 138px;
            color: #7c8e9b;
          }

          &_user {
            @extend .creation-tab__baseline_selector_table_column;
            flex: 1 1;
            display: flex;
            justify-content: space-between;

            &_manage-wrapper {
              display: flex;
            }

            &_email {
              max-width: 250px;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }

        &_button {
          padding: 7px;
          display: flex;
          align-items: center;
          border: none;
          background: transparent;
          outline: none;
          font-size: 14px;
          line-height: 24px;
          color: $rfx-dark-march;

          span {
            margin-left: 16px;
            width: 6px;
            height: 6px;
            border-left: 2px solid $rfx-bright-blue;
            border-bottom: 2px solid $rfx-bright-blue;
            transform: translate(5px, -2px) rotate(-45deg);
          }
        }
      }

      &_content {
        color: $rfx-dark-march;
        overflow: hidden;
        padding: 0px 2px 24px;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0px;
        white-space: break-spaces;

        &::v-deep .mce-panel {
          border: none !important;

          .mce-top-part .mce-first {
            display: none;
          }
        }

        &::v-deep #mceu_15 {
          box-shadow: none !important;
        }

        &_collapsed {
          //padding: 0px 2px 24px !important;
          //text-overflow: ellipsis;
          //display: -webkit-box;
          //-webkit-line-clamp: 8;
          //-webkit-box-orient: vertical;
        }

        &-uncollapsed {
          background-color: #dbdee5;
        }
      }
    }

    &__copy-baseline {
      background: transparent;
      border: none;
      margin-left: auto;
      outline: none;
      margin-right: 12px;

      span {
        font-size: 18px;
      }
    }

    &__clone-baseline,
    &__edit-meta-data,
    &__save-as-baseline,
    &__create-new-baseline {
      padding: 7px;
      display: flex;
      align-items: center;
      background: transparent;
      font-size: 10px;
      font-weight: 900;
      line-height: 24px;
      letter-spacing: 1.25px;
      color: $rfx-dark-march;
      border: none;
      text-outline: none;
      text-transform: uppercase;

      span {
        padding-right: 13px;
        font-size: 16px;
      }

      &_disabled {
        pointer-events: none;
        cursor: default;
        opacity: .4;
      }
    }

    &__edit-meta-data {
      margin-right: 24px;
    }

    &__save-as-baseline {
      margin-right: 24px;

      &_disabled {
        pointer-events: none;
        opacity: 0.4;
      }

      span {
        font-size: 19px;
      }
    }

    &__editor-drag-wrapper {
      position: relative;

      &_vdr {

        &:not(.creation-tab__editor-drag-wrapper_dragging) {
          position: static !important;
          transform: none !important;
          width: auto !important;
        }
      }

      //.dragging {
      //  pointer-events: none !important;
      //}

      &_dragging {
        position: fixed !important;
        box-shadow: 0 0 7px 3px rgba(0, 0, 0, .4);
        border-radius: 4px;
        overflow: hidden;
      }

      &_collapse-button {
        position: absolute;
        right: 24px;
        font-size: 20px;
        z-index: 9;
        cursor: pointer;
      }

      &_shifted {
        width: 78vw;
        margin-left: 100px;
      }

      &::v-deep .handle {
        position: absolute;
        z-index: 1000;
        display: block !important;
      }

      &::v-deep .handle-tm {
        height: 6px;
        width: 98.6%;
        left: 6px;
        cursor: ns-resize;
      }

      &::v-deep .handle-bm {
        height: 6px;
        width: 98.6%;
        left: 6px;
        cursor: ns-resize;
        bottom: 0;
      }

      &::v-deep .handle-tl {
        height: 12px;
        width: 6px;
        cursor: nwse-resize;
      }

      &::v-deep .handle-bl {
        height: 12px;
        width: 6px;
        cursor: nesw-resize;
        bottom: 0;
      }

      &::v-deep .handle-tr {
        right: 0;
        height: 12px;
        width: 6px;
        cursor: nesw-resize;
      }

      &::v-deep .handle-br {
        right: 0;
        height: 12px;
        width: 6px;
        bottom: 0;
        cursor: nwse-resize;
      }

      &::v-deep .handle-ml, .handle-mr {
        top: 12px;
        height: 95.2%;
        width: 6px;
        cursor: ew-resize;
      }

      &::v-deep .handle-mr {
        right: 0;
      }
    }

    &__optimized {
      margin-left: 8px;
      overflow-y: scroll;
      width: -webkit-fill-available;
    
      &_header {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 24px;
        width: -webkit-fill-available;
      }

      &_difference {
        width: -webkit-fill-available;
        border-top: 1px solid #dbdee5;
        padding: 6px 24px;
        display: flex;

        &-uncollapsed {
          border-top: 0 !important;
          padding: 12px 24px !important;
          background-color: #dbdee5;

          span {
            color: $rfx-dark-march !important;
          }
        }

        span {
          font-size: 12px;
          line-height: 16px;
          color: $rfx-shaded-grey;
          margin-right: 40px;
        }

        &_autosave {
          margin-left: auto;
          margin-right: 0 !important;
          color: $rfx-dark-march !important;
          line-height: 1 !important;
          display: flex;
          align-items: center;

          span  {
            margin-left: auto;
            margin-right: 8px !important;
            color: $rfx-dark-march !important;
            line-height: 1 !important;
            font-size: 16px !important;

          }
        }

        &_score {
          margin-right: 0 !important;
          padding-left: 8px;
        }
      }

      &_content {
        overflow: hidden;
        background-color: #fff;

        &::v-deep .mce-tinymce{
          box-shadow: none !important;
        }

        //.creation-tab__empty-baseline {
        //  top: calc(50% + 23.5px );
        //}

        textarea {
          color: $rfx-dark-march;
          font-size: 14px;
          outline: none;
          line-height: 20px;
          width: -webkit-fill-available;
          letter-spacing: 0px;
          border: none;
        }

        &::v-deep #mceu_15 {
          box-shadow: none !important;
        }

        &::v-deep .mce-panel {
          border: none !important;

          #mceu_26 {
            padding-left: 16px;
          }
        }
      }
    }
  }

  .creation-tab__print {
    padding-bottom: 0;

    .container {
      width: calc(100% - 60px);
    }
  }

  @media print {
    @page {
      margin: 0;
      size: auto;
    }
  }
</style>
